
import jQuery from 'jquery';


/**
 * Scrolls the window to a given offset from the top. Uses the standard
 * `scroll` event if it's present, otherwise uses the jQuery animate method.
 */
export default function(pixelOffset) {
  if (window) {
    if (window.scroll) {
      window.scroll({
        top: pixelOffset, 
        behavior: 'smooth'
      });
    } else {
      jQuery(window).animate({
        top: pixelOffset
      });
    }
  }
};

